/**
 * Responsible for handling category menu
 * @module modules/toggleContent
 */

import $ from 'jquery';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'categoryMenu';
export const CLICK_EVENT = 'click';

export const DEFAULTS = {
  speed: 500,
};

const closeAllCategoryMenu = () => {
  $("[category-body-lock='true']").categoryMenu('toggle');
};

const setMenuHeight = ($el) => {
  if ($el.length) {
    $el.show();
    const menuHeight = $(window).height() - $el.offset().top;
    $el.hide();
    $el.css({ maxHeight: menuHeight });
  }
};
/**
 * Handles the click event when a label has been iteracted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 */
const itemClickHandler = ({ currentTarget }, $el) => {
  const $scrollEl = $($el.attr('data-toggle-select-this'));
  const fasterNavigation = window.rcProps && window.rcProps.fasterCategoryNav === true;
  if ($el.hasClass('is-active')) {
    $el.attr('category-body-lock', '');
    enableBodyScroll($scrollEl[0]);
    // AB Test 700 - Change slideUp parameter to 200
    if (fasterNavigation) {
      $scrollEl.slideUp(0);
    } else {
      $scrollEl.slideUp();
    }
    $scrollEl.removeClass('is-active');
    $el.removeClass('is-active');
    $scrollEl.off('scroll.catmenu');
    $('html, body').stop();
  } else {
    $el.attr('category-body-lock', 'true');
    disableBodyScroll($scrollEl[0]);
    // AB Test 700 - Change slideDown parameter from 400 to 200
    let testId = 0;
    if (window.rcProps && window.rcProps.fasterCategoryNavTestId) {
      testId = window.rcProps.fasterCategoryNavTestId;
    }
    let testGroup = 'a';
    if (fasterNavigation) {
      testGroup = 'b';
      $scrollEl.slideDown(0, () => {
        $scrollEl.css('overflow', '');
      });
    } else {
      $scrollEl.slideDown(400, () => {
        $scrollEl.css('overflow', '');
      });
    }
    $scrollEl.addClass('is-active');
    $el.addClass('is-active');
    $scrollEl.on('scroll.catmenu', () => {
      $('html, body').animate({ scrollTop: -1 }, 0);
    });
    if (typeof window.logEngagementWithDetails === 'function' && testId > 0) {
      window.logEngagementWithDetails(window.location.href, 'Category Menu', 'click', `abtest id :${testId} & group = ${testGroup}`);
    }
  }
};
/**
 * Applies any sort of event handlers for the toggleContent.
 * @private
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
const applyEventHandlers = ($el, opts = {}) => {
  $el
    .on(CLICK_EVENT, evt => itemClickHandler(evt, $el, opts));
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
  const opts = $.extend({}, DEFAULTS, options);
  return opts;
};
/**
 * Initializes an categoryMenu
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @see DEFAULTS
 */
export default function categoryMenu(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions($el, options);
  setMenuHeight($($el.attr('data-toggle-select-this')));
  applyEventHandlers($el, opts);
  return {
    toggle: () => itemClickHandler(opts, $el),
  };
}
$.categoryMenu = (options) => {
  $('<div/>').categoryMenu(options);
};
$.categoryMenu.close = () => {
  closeAllCategoryMenu();
};
// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, categoryMenu);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/category-menu.js